import { Eye , EyeOff} from 'lucide-react';
import React from 'react';

export const LoginPanel = ({ onLogin, email, setEmail, password, setPassword, clientUid, setClientUid, invalidCreds }) => {
  const [showPassword, setShowPassword] = React.useState(false);
  return (
    <div className="login-panel-main">
      <div className="login-box">
        <h2 className="login-box__title">Welcome</h2>
        <p className="login-box__subtitle">
          Please enter your details
        </p>

        <form onSubmit={onLogin} className="login-form">
          <div className="form-group" style={{marginTop:'30px'}}>
            <input
              id="clientUid"
              name="clientUid"
              type="text"
              value={clientUid}
              onChange={(e) => setClientUid(e.target.value)}
              placeholder=" "
              className="form-group__input"
            />
            <label htmlFor="clientUid" className="form-group__label">
              Tenant ID / Client UID
            </label>
          </div>

          <div className="form-group" style={{marginTop:'30px'}}>
            <input
              id="email"
              name="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder=" "
              required
              className="form-group__input"
            />
            <label htmlFor="email" className="form-group__label">
              Email Address
            </label>
          </div>

          <div className="form-group" style={{marginTop:'30px'}}>
            <input
              id="password"
              name="password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder=" "
              required
              className="form-group__input"
            />
            <label htmlFor="password" className="form-group__label">
              Password
            </label>
            <div className="password-icon" onClick={() => setShowPassword((prev) => !prev)}>
              {showPassword ? <EyeOff  width="16px"/> : <Eye width="16px"/>}
            </div>
          </div>

          {invalidCreds && (
            <p className="form__error-message">{invalidCreds}</p>
          )}

          <div className='form__button-container' style={{marginTop:'30px'}}>
            <button type="submit" className="form__submit-button">
              Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};